import React, { useState } from 'react';
import { useQuery } from 'react-query';

import { handleApiErrors } from '../../api/axiosInstance';
import { COMPANY_API } from '../../api/company';
import MetabaseAPI from '../../api/metabase';
import Spinner from '../Spinner';
import Toast from '../Toast';

const MetabaseMonthlyMileageChart = props => {
  const { userId, companyId, t } = props;
  const [isLoadingIframe, setIsLoadingIframe] = useState(true);
  const internalName = 'last-12-months-mileage';

  const fetchCompanyReportsQuery = useQuery({
    enabled: !!userId,
    placeholderData: { documents: [], totalCount: 0 },
    queryKey: ['fetchCompanyReports', 'last-12-months-mileage', companyId],
    queryFn: () =>
      COMPANY_API.fetchCompanyReports(companyId, undefined, undefined, undefined, internalName),
    onError: error => handleApiErrors(error.response),
  });

  const firstDocument =
    fetchCompanyReportsQuery.data?.documents?.length === 1
      ? fetchCompanyReportsQuery.data.documents[0]
      : null;

  const metabaseReportUrlQuery = useQuery({
    enabled: !!firstDocument?._id,
    queryKey: ['fetchMetabaseReportURL', firstDocument?._id, companyId],
    queryFn: () => {
      return new MetabaseAPI().fetchMetabaseReportURL(firstDocument?._id, {
        companyId,
        userId,
      });
    },
    onError: error => {
      handleApiErrors(error.response, () => {
        Toast({
          type: 'error',
          message: t('errorLoadingReport'),
        });
      });
    },
  });

  return (
    <Spinner
      spinning={
        isLoadingIframe || fetchCompanyReportsQuery.isFetching || metabaseReportUrlQuery.isFetching
      }
    >
      <iframe
        title="monthly mileage chart"
        src={metabaseReportUrlQuery.data}
        frameBorder={0}
        width={800}
        height={450}
        allowTransparency
        onLoad={() => setIsLoadingIframe(false)}
      />
    </Spinner>
  );
};

export default MetabaseMonthlyMileageChart;
